var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFarmFarmer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0177 8.56851L12.428 6.71064C12.4349 6.6826 12.8729 5.04206 14.632 5H17.3645C19.1305 5.04206 19.5686 6.6826 19.5755 6.69662L19.9927 8.59656",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9134 12.8591C9.59118 12.4806 7.81819 11.7584 7.81819 10.7278C7.81819 9.13639 12.0316 8.28107 16.0017 8.28107C19.9718 8.28107 24.1853 9.13639 24.1853 10.7278C24.1853 11.7584 22.4123 12.4806 20.09 12.8591",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3751 10.5386C20.3751 10.9242 20.3542 11.3098 20.3055 11.6884C19.937 14.7871 18.1223 17.0376 16.0017 17.0376C13.8463 17.0376 12.0316 14.7521 11.6839 11.6112C11.6422 11.2607 11.6283 10.9031 11.6283 10.5456",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0036 27C14.0885 27 12.2459 26.9267 10.6863 26.7874C6 26.3844 6 25.6956 6 25.4757C6 21.1082 9.2354 17.4369 13.5227 16.9313L13.6315 16.9166L15.9964 20.0017L18.3685 16.9166L18.4846 16.9313C20.3779 17.1584 22.1552 18.0305 23.5045 19.3935C25.115 21.0203 26 23.1821 26 25.4757C26 25.7029 26 26.3844 21.3137 26.7948C19.7541 26.9267 17.9188 27 16.0036 27Z",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0562 17.375V26.5417",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4198 17.8334V26.5417",
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8182 14.1667C17.8182 14.1667 17.2459 14.2799 16.9091 14.1667C16.4328 14.0066 16.5021 13.25 16 13.25C15.4979 13.25 15.5672 14.0066 15.0909 14.1667C14.7541 14.2799 14.1818 14.1667 14.1818 14.1667",
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFarmFarmer);
export default __webpack_public_path__ + "static/media/Farm_farmer.86815319021377a1d6c41af750074f7d.svg";
export { ForwardRef as ReactComponent };